export const getFirstName = (fullName?: string): string =>
  fullName?.trim().split(' ')[0] ?? '';
